/* eslint-disable react/style-prop-object */
import React from 'react';

export const InfoPerson = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="50"
    height="39"
    viewBox="0 0 50 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.67"
      d="M48.8119 13.7125C51.9995 18.9257 48.1953 27.058 40.3149 31.8765C32.4345 36.6949 23.4621 36.375 20.2745 31.1618C17.0869 25.9486 20.8911 17.8163 28.7715 12.9978C36.6518 8.17931 45.6242 8.49928 48.8119 13.7125Z"
      fill="#E8E6FF"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.67">
      <path
        d="M40.0618 31.4129C36.2497 39.197 24.4587 41.2463 13.726 35.9901C2.99321 30.7339 -2.61707 20.1627 1.19505 12.3786C5.00717 4.59451 16.7981 2.54526 27.5309 7.80144C38.2636 13.0576 43.8739 23.6288 40.0618 31.4129Z"
        fill="#EFEEF8"
      />
    </g>
    <mask
      id="mask0_165_19249"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="10"
      y="0"
      width="36"
      height="38"
    >
      <rect x="10" y="0.0958252" width="36" height="37" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_165_19249)">
      <path
        d="M28 18.5958C26.35 18.5958 24.9375 17.992 23.7625 16.7844C22.5875 15.5767 22 14.125 22 12.4292C22 10.7333 22.5875 9.28161 23.7625 8.07397C24.9375 6.86633 26.35 6.26251 28 6.26251C29.65 6.26251 31.0625 6.86633 32.2375 8.07397C33.4125 9.28161 34 10.7333 34 12.4292C34 14.125 33.4125 15.5767 32.2375 16.7844C31.0625 17.992 29.65 18.5958 28 18.5958ZM16 30.9292V26.6125C16 25.7389 16.219 24.9357 16.657 24.2029C17.094 23.4711 17.675 22.9125 18.4 22.5271C19.95 21.7306 21.525 21.1329 23.125 20.7341C24.725 20.3364 26.35 20.1375 28 20.1375C29.65 20.1375 31.275 20.3364 32.875 20.7341C34.475 21.1329 36.05 21.7306 37.6 22.5271C38.325 22.9125 38.906 23.4711 39.343 24.2029C39.781 24.9357 40 25.7389 40 26.6125V30.9292H16ZM19 27.8458H37V26.6125C37 26.3299 36.9315 26.0729 36.7945 25.8417C36.6565 25.6104 36.475 25.4306 36.25 25.3021C34.9 24.6083 33.5375 24.0878 32.1625 23.7404C30.7875 23.394 29.4 23.2208 28 23.2208C26.6 23.2208 25.2125 23.394 23.8375 23.7404C22.4625 24.0878 21.1 24.6083 19.75 25.3021C19.525 25.4306 19.344 25.6104 19.207 25.8417C19.069 26.0729 19 26.3299 19 26.6125V27.8458ZM28 15.5125C28.825 15.5125 29.5315 15.2103 30.1195 14.606C30.7065 14.0027 31 13.2771 31 12.4292C31 11.5813 30.7065 10.8557 30.1195 10.2523C29.5315 9.64801 28.825 9.34585 28 9.34585C27.175 9.34585 26.469 9.64801 25.882 10.2523C25.294 10.8557 25 11.5813 25 12.4292C25 13.2771 25.294 14.0027 25.882 14.606C26.469 15.2103 27.175 15.5125 28 15.5125Z"
        fill="#5D54C0"
      />
    </g>
  </svg>
);
